<div [formGroup]="formGroup">
	<div class="field-row">
		<div class="field-row-title">
			Spreader Type
		</div>
		<div class="field-row-element">
			<mat-form-field subscriptSizing="dynamic">
				<mat-select formControlName="isLiquid">
					<mat-option [value]="true">Liquid</mat-option>
					<mat-option [value]="false">Granular</mat-option>
				</mat-select>
			</mat-form-field>
		</div>
	</div>

	<app-input-connection-configuration formControlName="connection"
						   [availableInputs]="availableInputs()">
	</app-input-connection-configuration>

	<div class="field-row">
		<div class="field-row-title">
			Rate
		</div>
		<div class="field-row-element">
			<mat-form-field>
				<input matInput
					   type="number"
					   formControlName="rate">
				<div matSuffix>
					{{(formGroup.controls.isLiquid.value ? 'liquid' : 'granular') | rateUnit: configuration.useMetricSystem}}
				</div>
			</mat-form-field>
		</div>
	</div>
</div>
